import script from "./BetslipComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BetslipComponent.vue?vue&type=script&setup=true&lang=js"

import "./BetslipComponent.vue?vue&type=style&index=0&id=2700fa5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2700fa5c"]])

export default __exports__